export enum CostEnums {
  COST_BY_TENANT = 'COST_BY_TENANT',
  COST_BY_SERVICE = 'COST_BY_SERVICE',
  COST_BY_ENV = 'COST_BY_ENV',
  SERVICE_COST_BY_TENANT = 'SERVICE_COST_BY_TENANT',
  CONTROL_DATA_PLANE_COST_BY_TENANT = 'CONTROL_DATA_PLANE_COST_BY_TENANT',
  TENANT_COST_BY_CONTROL_DATA_PLANE = 'TENANT_COST_BY_CONTROL_DATA_PLANE',
  ENV_COST_BY_TENANT = 'ENV_COST_BY_TENANT',
  TENANT_COST_BY_ENV = 'TENANT_COST_BY_ENV',
  COST_BY_CONTROL_DATA_PLANE = 'COST_BY_CONTROL_DATA_PLANE',
}

export enum DBBackupType {
  snapshot = 'snapshotBackup',
  backup = 'dbNativeBackup',
}

export enum OTPRequestType {
  ONBOARD_OTP = 'ONBOARD_TENANT',
  FORGOT_PASSWORD_OTP = 'FORGOT_PASSWORD',
  METADATA_UPDATE_OTP = 'UPDATE_METADATA',
  BILLING_OTP = 'TOGGLE_BILLING',
  ADD_CREDITS_OTP = 'ADD_CREDITS',
  SILENCE_ALERT_OTP = 'SILENCE_ALERT',
  DB_ENGINE_CONFIG_OTP = 'UPDATE_ENGINE_CONFIG',
  TENANT_FLAG_TOGGLE_OTP = 'TOGGLE_TENANT_FLAG',
  TENANT_ONGOING_ISSUE_UPDATE_OTP = 'UPDATE_TENANT_ONGOING_ISSUE',
}
